import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/Product Engineer Icon.png";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Banner = () => {
  // <<< No state needed here anymore, simplifying the component.

  return (
    // <<< Added 'd-flex' and 'align-items-center' to vertically center content.
    <section className="banner d-flex align-items-center" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <span className="tagline">Welcome to my Portfolio</span>
                  {/* <<< Simplified and more impactful H1 structure */}
                  <h1>
                    {`Hi! I'm Pushkar,`}
                    <br />
                    <span className="gradient-text">Software Engineer</span>
                  </h1>
                  <p>
                    I build end-to-end digital solutions with a mobile-first focus. My passion is transforming ideas from Figma mockups into fully functional, user-centric applications. With expertise in Kotlin, Flutter, React, PostgreSQL, and Firebase, I own the entire development lifecycle to deliver products that succeed.
                  </p>
                  {/* <<< Added a clear Call-to-Action button */}
                  <button onClick={() => window.location.href = '#connect'}>
                    Contact Me <ArrowRightCircle size={25} />
                  </button>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => (
                // <<< Added a different animation for variety
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img" />
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
